<template>
  <div id="pipenetwork">
    <div class="title">管网统计</div>
    <div class="content">
      <div class="length_net">
        <div class="length_net_title">长度统计</div>
        <div class="length_net_body">
          <div class="length_net_1">
            <p style="color: #b0b7c2">给水总长</p>
            <p style="color: #588ae6">9682米</p>
          </div>
          <div class="length_net_2">
            <p style="color: #b0b7c2">消防总长</p>
            <p style="color: #588ae6">2830米</p>
          </div>
        </div>
      </div>
      <div class="type_net_title">类别统计</div>
      <div class="type_net dian_box" ref="scroll_4">
        <div>
          <div class="type_net_body_1">
            <div class="length_net_1">
              <p style="color: #b0b7c2">水表井</p>
              <p style="color: #588ae6">26个</p>
            </div>
            <div class="length_net_2">
              <p style="color: #b0b7c2">阀门井</p>
              <p style="color: #588ae6">55个</p>
            </div>
          </div>

          <div class="type_net_body_2">
            <div class="length_net_1">
              <p style="color: #b0b7c2">弯头</p>
              <p style="color: #588ae6">343个</p>
            </div>
            <div class="length_net_2">
              <p style="color: #b0b7c2">三通</p>
              <p style="color: #588ae6">161个</p>
            </div>
          </div>
          <div class="type_net_body_2">
            <div class="length_net_1">
              <p style="color: #b0b7c2">直接头</p>
              <p style="color: #588ae6">222个</p>
            </div>
            <div class="length_net_2">
              <p style="color: #b0b7c2">斜三通</p>
              <p style="color: #588ae6">7个</p>
            </div>
          </div>
        </div>
        <div class="custom-vertical-scrollbar" ref="vertical_4">
          <div class="custom-vertical-indicator"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BScroll from 'better-scroll' 
import ScrollBar from '@better-scroll/scroll-bar'
BScroll.use(ScrollBar)
export default {
  mounted(){
    this.$nextTick(() => { 
      new BScroll(this.$refs.scroll_4, {
          scrollX: false,
          scrollY: true,
          click: true,
          mouseWheel: true,
          scrollbar: {
            customElements: [this.$refs.vertical_4],
            fade: true,
            interactive: true,
            scrollbarTrackClickable: true
          }      
        }) 
      })
  }
};
</script>

<style scoped>
#pipenetwork {
  width: 100%;
  margin-top: 1.48vh;
  height: 27.5vh;
  background: url("@/assets/pengshui_bg.png") no-repeat center center;
  color: #ffffff;
  background-size: 100% 100%;
}
.title {
  height: 4.53vh;
  /* border: 1px solid red; */
  font-size: 18px;
  line-height: 4.53vh;
  text-align: start;
  margin-left: 20px;
}
.content {
  height: 22.5vh;
  width: 95%;
  /* border: 1px solid red; */
  display: flex;
  flex-direction: column;
}
.length_net {
  flex: 1;
  font-size: 12px;
  /* border: 1px solid red; */
}
.type_net {
  flex: 1.3;
  /* border: 1px solid red; */
}
.length_net_title {
  margin-top: 1vh;
  margin-bottom: 0.833vh;
  margin-left: 0.47vw;
  text-align: start;
}
.length_net_body {
  display: flex;
  width: 95%;
  justify-content: space-between;
}
.length_net_1,
.length_net_2 {
  width: 48%;
  background: url("@/assets/pengshui_18.png") no-repeat center center;
  background-size: 100% 100%;
  display: flex;
  height: 3.61vh;
  line-height: 3.61vh;
  text-align: center;
  justify-content: space-around;
}
.type_net_title {
  font-size: 12px;
  text-align: start;
  margin-left: 0.47vw;
  height: 2.4vh;
}
.type_net_body_1 {
  height: 3.61vh;
  display: flex;
  width: 95%;
  justify-content: space-between;
  font-size: 12px;
  margin-top: 10px;
}
.type_net_body_2 {
  display: flex;
  height: 3.61vh;
  width: 95%;
  justify-content: space-between;
  font-size: 12px;
  margin-top: 1.38vh;
}
.dian_box {
  overflow: hidden;
  cursor: pointer;
  position: relative;
  
}

.custom-vertical-scrollbar{
   position: absolute;
    top: 50%;
    right: .0625rem;
    height: 5rem;
    width: .4375rem;
    border-radius: .375rem;
    transform: translateY(-50%) translateZ(0);
    background-color: rgb(200, 200, 200, 0.3);
    z-index: 10;
}
</style>